import { render, staticRenderFns } from "./TgBannerSwiper.vue?vue&type=template&id=679df1dc&"
import script from "./TgBannerSwiper.vue?vue&type=script&lang=js&"
export * from "./TgBannerSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports